"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleTabs = exports.onClickCloseTabs = void 0;
const onClickCloseTabs = (e, tabid) => {
    var _a, _b, _c;
    const el = document.querySelector(`#${tabid}`);
    const target = e.target;
    if (((_a = target.parentElement) === null || _a === void 0 ? void 0 : _a.classList.contains('tab-button')) || (target.tagName === 'SPAN' && ((_c = (_b = target.parentElement) === null || _b === void 0 ? void 0 : _b.parentElement) === null || _c === void 0 ? void 0 : _c.classList.contains('tab-button')))) {
        return;
    }
    if (!el || el.contains(e.target)) {
        return;
    }
    else {
        document.querySelector(`#${tabid}`).classList.remove('mobile-block');
        document.querySelectorAll(`#${tabid} .nav-item button`).forEach(el => el.setAttribute('tabindex', '-1'));
    }
};
exports.onClickCloseTabs = onClickCloseTabs;
const toggleTabs = (tabid, open) => {
    const tabs = document.querySelector(`#${tabid} + .tab-content`);
    if (document.querySelector(`#${tabid}`).classList.contains('mobile-block')) {
        document.querySelector(`#${tabid}`).classList.remove('mobile-block');
        document.removeEventListener('mousedown', (e) => (0, exports.onClickCloseTabs)(e, tabid));
        document.querySelectorAll(`#${tabid} .nav-item button:not(.active)`).forEach(el => el.setAttribute('tabindex', '-1'));
        tabs.style.minHeight = '';
        if (open)
            open(false);
    }
    else {
        document.querySelector(`#${tabid}`).classList.add('mobile-block');
        document.addEventListener('mousedown', (e) => (0, exports.onClickCloseTabs)(e, tabid));
        tabs.style.minHeight = `${document.querySelector(`#${tabid}`).scrollHeight}px`;
        document.querySelectorAll(`#${tabid} .nav-item button:not(.active)`).forEach(el => el.setAttribute('tabindex', '0'));
        if (open)
            open(true);
    }
};
exports.toggleTabs = toggleTabs;
